enum BookingSystemEnum {
  Onlinebuchung = 'onlinebuchung',
  Anfrage = 'anfrage'
}

export default BookingSystemEnum
